<template>
  <div class="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',

  data() {
    return {}
  },
}
</script>

<style>
.app {
  height: 100%;
}
</style>
